{
  "common.back": "Retour",
  "common.close": "Fermer",
  "common.confirm": "Confirmer",
  "common.continue": "Continuer",
  "common.minus": "Diminuer",
  "common.plus": "Augmenter",
  "common.loading": "Chargement…",
  "common.edit": "Modifier",
  "search.title": "Rechercher un ferry",
  "search.subtitle": "Choisissez votre traversée, vos passagers et votre véhicule.",
  "search.directionRoundTrip": "Aller-retour",
  "search.directionOneWay": "Aller simple",
  "search.journey": "Traversée",
  "search.journeyPlaceholder": "Choisir une traversée",
  "search.outDate": "Date aller",
  "search.retDate": "Date retour",
  "search.journeyCard": "Traversée",
  "search.datesCard": "Dates",
  "search.datesPlaceholder": "Choisir vos dates",
  "search.pickReturn": "Date retour manquante",
  "search.passengersCard": "Passagers",
  "search.vehicleCard": "Véhicule",
  "search.animalsCard": "Animaux",
  "search.passengersSummary": "{n} passager | {n} passagers",
  "search.passengersDetail": "{adults} adulte(s), {children} enfant(s), {babies} bébé(s)",
  "search.vehicleNone": "Aucun véhicule",
  "search.animalsSummary": "{n} animal | {n} animaux",
  "search.submit": "Rechercher",
  "search.submitting": "Recherche en cours…",
  "passengers.title": "Passagers",
  "passengers.subtitle": "Sélectionnez le nombre et l'âge",
  "passengers.adults": "Adultes",
  "passengers.children": "Enfants",
  "passengers.babies": "Bébés",
  "passengers.senior": "Sénior",
  "passengers.junior": "Jeune",
  "passengers.agesTitle": "Âges",
  "passengers.childrenAges": "Âges des enfants",
  "passengers.babyAges": "Âges des bébés",
  "passengers.adult": "Adulte",
  "passengers.child": "Enfant",
  "passengers.baby": "Bébé",
  "passengers.years": "ans",
  "passengers.total": "Total passagers",
  "vehicle.title": "Véhicule",
  "vehicle.typeNone": "Aucun",
  "vehicle.typeBike": "Vélo",
  "vehicle.typeCar": "Voiture",
  "vehicle.typeVan": "Van",
  "vehicle.typeMoto": "Moto",
  "vehicle.plate": "Plaque d'immatriculation",
  "vehicle.searchBrand": "Rechercher une marque…",
  "vehicle.searchModel": "Rechercher un modèle…",
  "vehicle.luggageToggle": "Bagages volumineux (galerie de toit)",
  "vehicle.luggageHeight": "Hauteur",
  "vehicle.luggageLength": "Longueur",
  "vehicle.step.type": "Type",
  "vehicle.step.brand": "Marque",
  "vehicle.step.model": "Modèle",
  "vehicle.step.luggage": "Bagages",
  "vehicle.step.plate": "Plaque",
  "vehicle.roof.none": "Sans galerie de toit",
  "vehicle.roof.with": "Avec galerie de toit",
  "vehicle.roof.heightExtra": "Hauteur en +",
  "vehicle.trailer.title": "Caravane / Remorque",
  "vehicle.trailer.none": "Sans caravane/remorque",
  "vehicle.trailer.with": "Avec caravane/remorque",
  "vehicle.trailer.caravan": "Caravane",
  "vehicle.trailer.standard": "Remorque standard",
  "vehicle.trailer.lengthExtra": "Longueur en +",
  "vehicle.priority.title": "Débarquement",
  "vehicle.priority.standard": "Standard",
  "vehicle.priority.priority": "Débarquement prioritaire",
  "vehicle.maxDims": "Longueur max {length}m (+{trailer}cm) / Hauteur max {height}m (+{roof}cm)",
  "vehicle.summary.length": "Longueur",
  "vehicle.summary.height": "Hauteur",
  "place.title": "Choisir une place",
  "place.titleInline": "Places disponibles",
  "place.empty": "Aucune place disponible pour ce trajet.",
  "place.capacity": "{n} pers.",
  "place.all": "Toutes",
  "place.seat": "Fauteuil",
  "place.cabin": "Cabine",
  "place.suite": "Suite",
  "place.bed": "Lit",
  "place.deck": "Passage pont",
  "place.shared": "Partagée",
  "place.features.window": "Hublot",
  "place.features.shower": "Douche",
  "place.features.toilet": "Toilettes",
  "results.choosePlace": "Choisir une place",
  "results.choosePlaceRequired": "Choisir une place (obligatoire)",
  "results.placeSelected": "Place : {name}",
  "results.placeChosen": "Place choisie",
  "results.fastest": "LE PLUS RAPIDE",
  "results.cheapest": "MEILLEUR PRIX",
  "results.pricePerPassenger": "pour 1 passager",
  "results.pricePerPassengers": "pour {n} passagers",
  "results.choosePlaceCta": "Choisir la place {dir}",
  "results.choose": "Choisir {dir}",
  "results.chooseSailing": "Choisir",
  "results.pickSailingHint": "Touchez un horaire pour choisir votre place",
  "results.availableCount": "{n} traversées disponibles",
  "results.startingFrom": "à partir de",
  "results.selectToContinue": "Choisissez votre traversée et votre place pour continuer",
  "journey.title": "Votre traversée",
  "journey.subtitle": "Choisissez votre départ et destination",
  "journey.continueToDates": "Continuer vers les dates",
  "journey.search": "Tapez un nom de port ou compagnie…",
  "journey.empty": "Aucune traversée trouvée",
  "journey.clear": "Effacer",
  "journey.loadingVariants": "Chargement des disponibilités…",
  "journey.departureLabel": "Départ",
  "journey.destinationLabel": "Destination",
  "journey.choosePort": "Choisir un port",
  "journey.destinationDisabled": "Sélectionnez d'abord un départ",
  "journey.stepDeparture": "Port de départ",
  "journey.stepDestination": "Où allez-vous ?",
  "journey.fromPrefix": "Depuis {port}",
  "journey.searchPort": "Rechercher un port…",
  "journey.noPortFound": "Aucun port trouvé",
  "journey.swap": "Inverser le sens",
  "journey.returnInfo": "Retour : {to} → {from}",
  "journey.returnLabel": "Retour",
  "calendar.title": "Choisissez vos dates",
  "calendar.tabOutward": "Aller",
  "calendar.tabReturn": "Retour",
  "calendar.tabSelect": "Sélectionner",
  "calendar.empty": "Choisissez d'abord une traversée pour voir les départs.",
  "calendar.noDepartures": "Aucun départ disponible sur cette traversée.",
  "calendar.addReturn": "Ajouter un retour",
  "calendar.departuresOn": "Départs du {date}",
  "calendar.noOutwardYet": "Sélectionnez la date aller en premier",
  "calendar.weekday.mon": "Lun",
  "calendar.weekday.tue": "Mar",
  "calendar.weekday.wed": "Mer",
  "calendar.weekday.thu": "Jeu",
  "calendar.weekday.fri": "Ven",
  "calendar.weekday.sat": "Sam",
  "calendar.weekday.sun": "Dim",
  "passengers.travelWithPets": "Vous voyagez avec des animaux ?",
  "passengers.petsSection": "Animaux",
  "animals.title": "Animaux",
  "animals.subtitle": "Vos compagnons à bord",
  "animals.cats": "Chats",
  "animals.dogs": "Chiens",
  "animals.dogs30": "Chiens > 30 kg",
  "animals.total": "Total animaux",
  "tariff.title": "Tarification",
  "tariff.subtitle": "Choisissez votre type de tarif",
  "tariff.outward": "Aller",
  "tariff.return": "Retour",
  "tariff.ticket": "Tarif standard",
  "tariff.presale": "Tarif prévente",
  "tariff.option": "Option (annulable)",
  "tariff.balance": "Reste",
  "tariff.payToday": "Payer aujourd'hui",
  "tariff.remaining": "Solde restant",
  "tariff.dueDate": "Échéance",
  "tariff.optionValidUntil": "Option valide jusqu'au",
  "tariff.presaleTitle": "Paiement prévente",
  "tariff.optionTitle": "Paiement option",
  "tariff.presaleDesc": "Le paiement initial sécurise votre réservation. Le solde restant devra être réglé avant la date d'échéance.",
  "tariff.optionDesc": "Cette option vous permet de réserver vos places jusqu'à la date limite. Le paiement complet est requis avant expiration pour émettre les billets.",
  "tariff.onlyOne": "(seul tarif disponible)",
  "summary.empty": "Choisissez un trajet pour voir le récap.",
  "summary.outward": "Voyage aller",
  "summary.return": "Voyage retour",
  "summary.passengers": "Passagers",
  "summary.vehicle": "Véhicule",
  "summary.places": "Installation",
  "summary.placeOutward": "Places",
  "summary.placeReturn": "Places retour",
  "summary.tariffOutward": "Tarifs",
  "summary.tariffReturn": "Tarifs retour",
  "summary.tariffsInclTaxes": "Toutes taxes comprises",
  "summary.total": "Total",
  "summary.group": "Groupe {group}",
  "summary.adult": "Adulte(s)",
  "summary.adults": "Adulte(s)",
  "summary.child": "Enfant(s)",
  "summary.children": "Enfant(s)",
  "summary.baby": "Bébé(s)",
  "summary.babies": "Bébé(s)",
  "results.stepSailing": "Traversée",
  "results.amenitiesInfo": "Véhicules, cabines et animaux acceptés à bord",
  "results.stepPlace": "Choisissez votre place",
  "results.placeGroup": "Groupe {group} · {count} passagers",
  "results.stepTariff": "Tarif",
  "results.title": "Votre traversée",
  "results.subtitle": "Choisissez votre départ, votre place et votre tarif.",
  "results.loading": "Recherche des disponibilités…",
  "results.emptyTitle": "Aucune disponibilité",
  "results.emptyText": "Aucune traversée ne correspond à votre recherche pour ces dates. Essayez d'autres dates ou un autre trajet.",
  "results.newSearch": "Nouvelle recherche",
  "results.searching": "Recherche des traversées…",
  "results.errorTitle": "La recherche a échoué",
  "results.errorText": "Impossible de récupérer les disponibilités pour le moment. Vérifiez votre connexion et réessayez.",
  "results.retry": "Réessayer",
  "results.modifySearch": "Modifier la recherche",
  "steps.aria": "Progression de la réservation",
  "steps.trip": "Traversée",
  "steps.options": "Options",
  "steps.details": "Coordonnées",
  "steps.summary": "Récapitulatif",
  "booking.subtitle": "Encore quelques informations pour finaliser.",
  "results.outwardTrip": "Trajet aller",
  "results.returnTrip": "Trajet retour",
  "results.continue": "Continuer",
  "results.total": "Total",
  "results.noAvailabilityDate": "Pas de disponibilité pour cette date",
  "options.title": "Options",
  "options.subtitle": "Ajoutez des repas et services à votre traversée.",
  "options.outwardGroup": "Voyage aller · Repas & services",
  "options.returnGroup": "Voyage retour · Repas & services",
  "options.none": "Aucun repas ni service disponible pour ce trajet.",
  "options.service": "Service",
  "options.continue": "Continuer",
  "booking.title": "Vos coordonnées",
  "booking.passengers": "Passagers",
  "booking.passengersGroup": "Groupe {group} · {count} passagers",
  "booking.contact": "Contact",
  "booking.vehicle": "Véhicule",
  "booking.vehicleRoofExtra": "Galerie de toit +{cm} cm",
  "booking.passengerN": "Passager {n}",
  "booking.firstName": "Prénom",
  "booking.lastName": "Nom",
  "booking.gender": "Genre",
  "booking.genderMale": "Homme",
  "booking.genderFemale": "Femme",
  "booking.birthDate": "Date de naissance",
  "booking.passportNumber": "Numéro de passeport",
  "booking.fullName": "Nom complet",
  "booking.email": "Email",
  "booking.phone": "Téléphone",
  "booking.submit": "Confirmer et payer",
  "booking.submitting": "Traitement…",
  "booking.required": "Ce champ est obligatoire",
  "booking.invalidEmail": "Adresse email invalide",
  "booking.invalidPhone": "Numéro de téléphone invalide",
  "booking.requiredHint": "Tous les champs sont obligatoires",
  "summary.title": "Résumé de votre voyage",
  "summary.subtitle": "Vérifiez l'ensemble des informations avant de continuer.",
  "summary.reference": "Référence",
  "summary.traveler": "Voyageur principal",
  "summary.otherTravelers": "Autres voyageurs",
  "summary.arrival": "Arrivée",
  "summary.duration": "Durée",
  "summary.durationFormat": "{hours} h {minutes}",
  "summary.priceDetails": "Détail du prix",
  "summary.tickets": "Billets",
  "summary.meals": "Repas",
  "summary.taxesIncluded": "Taxes et frais inclus",
  "summary.trustSecure": "Paiement sécurisé",
  "summary.trustEncrypted": "Vos données sont chiffrées",
  "summary.trustNoCardStored": "Aucune carte stockée chez nous",
  "summary.redirectInfo": "Vous serez redirigé vers une page de paiement sécurisée.",
  "summary.passengerDetails": "Détail des passagers",
  "summary.passenger": "Passager {n}",
  "summary.vehicleDetails": "Véhicule",
  "summary.vehiclePlate": "Plaque",
  "summary.vehicleBrandModel": "{brand} {model}",
  "summary.contactDetails": "Contact",
  "summary.contactName": "Nom",
  "summary.contactEmail": "Email",
  "summary.contactPhone": "Téléphone",
  "summary.placesDetails": "Installation",
  "summary.mealsDetails": "Repas",
  "summary.petsDetails": "Animaux",
  "summary.b2cCta": "Procéder au paiement",
  "summary.agentCta": "Continuer dans FerryGate",
  "summary.b2cHelper": "Vous allez être redirigé vers la page de paiement de l'organisation.",
  "summary.agentHelper": "Vous serez redirigé vers la page de confirmation FerryGate pour finaliser l'émission.",
  "summary.redirecting": "Redirection en cours…",
  "summary.missingCheckoutUrl": "URL de paiement non configurée — contactez l'administrateur.",
  "summary.checkoutUnavailable": "Paiement temporairement indisponible. Réessayez plus tard.",
  "summary.missingBooking": "Réservation introuvable, recommencez la recherche.",
  "summary.newBooking": "Nouvelle recherche",
  "summary.years": "ans",
  "summary.notProvided": "Non renseigné",
  "booking.ageBand": "{min} à {max} ans au départ",
  "booking.ageBandAdult": "À partir de {min} ans au départ",
  "booking.ageOutOfBand": "Un {type} doit avoir entre {min} et {max} ans à la date de départ",
  "booking.birthDateAfterDeparture": "La date de naissance ne peut pas être postérieure au départ"
}
